// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectCompany_addressContainer__CQDaC {
  position: relative;
  width: 100%;
  height: 68px;
}
.SelectCompany_addressContainer__CQDaC > ul {
  position: absolute;
  z-index: 1;
  top: calc(100% + 8px);
  left: 0;
  width: inherit;
  border-radius: 8px;
  margin: 0;
  padding: 0;
  font-weight: 300;
  background: #FFF;
}
.SelectCompany_addressContainer__CQDaC > ul li {
  list-style-type: none;
}
.SelectCompany_addressContainer__CQDaC > ul > li:first-child {
  max-height: 216px;
  overflow: scroll;
}
.SelectCompany_addressContainer__CQDaC > ul .SelectCompany_item__AoXc5 {
  display: block;
  list-style: none;
  padding: 12px;
  cursor: pointer;
  color: #00007a;
  font-size: 16px;
  line-height: 24px;
}
.SelectCompany_addressContainer__CQDaC > ul .SelectCompany_item__AoXc5 .SelectCompany_address__Y0pec {
  font-size: 14px;
  display: block;
}
.SelectCompany_addressContainer__CQDaC > ul .SelectCompany_item__AoXc5 .SelectCompany_siret__iq7my {
  font-size: 12px;
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/components/form/SelectCompany/SelectCompany.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAIF;AAFE;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAIJ;AAFI;EACE,qBAAA;AAIN;AADI;EACE,iBAAA;EACA,gBAAA;AAGN;AAAI;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,cC3BK;ED4BL,eAAA;EACA,iBAAA;AAEN;AAAM;EACE,eAAA;EACA,cAAA;AAER;AACM;EACE,eAAA;EACA,YAAA;AACR","sourcesContent":["@use 'styles/colors.scss';\n\n\n.addressContainer{\n  position: relative;\n  width: 100%;\n  height: 68px;\n\n  > ul {\n    position: absolute;\n    z-index: 1;\n    top: calc(100% + 8px);\n    left: 0;\n    width: inherit;\n    border-radius: 8px;\n    margin: 0;\n    padding: 0;\n    font-weight: 300;\n    background: #FFF;\n\n    li{\n      list-style-type: none;\n    }\n\n    > li:first-child{\n      max-height: 216px;\n      overflow: scroll;\n    }\n\n    .item{\n      display: block;\n      list-style: none;\n      padding: 12px;\n      cursor: pointer;\n      color: colors.$primary8;\n      font-size: 16px;\n      line-height: 24px;\n\n      .address{\n        font-size: 14px;\n        display: block;\n      }\n\n      .siret{\n        font-size: 12px;\n        float: right;\n      }\n    }\n  }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"addressContainer": `SelectCompany_addressContainer__CQDaC`,
	"item": `SelectCompany_item__AoXc5`,
	"address": `SelectCompany_address__Y0pec`,
	"siret": `SelectCompany_siret__iq7my`
};
export default ___CSS_LOADER_EXPORT___;
